
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    PACKAGES_DELETE_PACKAGE_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import {
    packagesDeletePackageResult,
} from 'Redux/actions';


function* deleteRole({ payload }) {
    try {
        let QUERY = `
            mutation deleteRole ($id: Int!) {
                result: deleteRole (id: $id)
            }
        `;
        let data = yield call(
            clientMutation,
            QUERY,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if(data?.result) yield put(packagesDeletePackageResult({ delete: true }))
        else yield put(packagesDeletePackageResult({ error: 'delete-role' }))

    } catch (exc) {
        yield put(packagesDeletePackageResult({ error: exc.error }))
        ExceptionManager(
            exc,
            "Modules/packages/.components/deletePackage/redux/saga",
            "deleteRole",
        )
    }
}

function* watchMethods() {
    yield takeEvery(PACKAGES_DELETE_PACKAGE_REQUEST, deleteRole);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}